import { Component } from "@angular/core";
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { FeedbackType } from "@app/shared/models/feedbackType";
import { IApiResponse } from "@app/shared/models/iApiResponse.model";
import { FeedbackService } from "@app/shared/services/feedback/feedback.service";
import { SpinnerService } from "@app/shared/services/spinner/spinner.service";
import { TextService } from "@app/shared/services/text/text.service";
import { SliderComponent } from "@app/shared/slider/slider.component";

import { AuthService } from "../../services/authentication/auth.service";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, SliderComponent, RouterModule],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.scss",
})
export class ForgotPasswordComponent {
  constructor(
    private textService: TextService,
    private fb: FormBuilder,
    private auth: AuthService,
    private spinner: SpinnerService,
    private feeedback: FeedbackService,
    private route: ActivatedRoute,
  ) {}
  text = {
    resetPassword: this.textService.labels.general.resetPassword,
    resetPasswordEmail: this.textService.labels.general.resetPasswordEmail,
  };

  form = this.fb.group({
    email: ["", [Validators.required, Validators.email]],
  });

  onSubmit() {
    const { email } = this.form.value;
    if (!email) {
      return;
    }
    this.auth
      .resetPassword(email)
      .subscribe({
        next: (res: IApiResponse) => {
          this.feeedback.openModal(
            FeedbackType.SUCCESS,
            "Sucesso!",
            res.detail
          );
        },
        error: (error) => {
          this.feeedback.openModal(FeedbackType.ERROR, "Oops!", error);
        },
      })
      .add(() => {
        this.spinner.hide();
      });
  }
}
